export enum BulkOperationsLabelsTranslation {
    LABELS_AVAILABLE_OPTIONS = "bulkOperations.labels.availableOptions",
    LABELS_ADD_TITLE = "bulkOperations.labels.add.title",
    LABELS_ADD_TITLE_PICKED_OPTIONS = "bulkOperations.labels.add.pickOptions",
    LABELS_REMOVE_TITLE = "bulkOperations.labels.remove.title",
    LABELS_REMOVE_TITLE_PICKED_OPTIONS = "bulkOperations.labels.remove.pickedOptions",
    LABELS_ADD_FAILED_TEXT = "bulkOperations.labels.add.failedText",
    LABELS_REMOVE_FAILED_TEXT = "bulkOperations.labels.remove.failedText",
}